import React from 'react';
import PropTypes from 'prop-types';
import { FormProvider, useForm } from 'react-hook-form';
import { zodResolver } from '@hookform/resolvers/zod';

export const Form = ({ children, onSubmit, validator, defaultValues, onError, ...rest }) => {
    const methods = useForm({
        mode: 'onChange',
        defaultValues,
        resolver: validator ? zodResolver(validator.schema, validator.options, validator.settings) : undefined
    });

    const doSubmit = async values => {
        if (onSubmit) {
            return onSubmit(values, methods);
        }
    };

    const handleError = async errors => {
        return onError?.(errors, methods);
    };

    const handleSubmit = onSubmit ? methods.handleSubmit(doSubmit, handleError) : methods.handleSubmit;

    return (
        <FormProvider {...methods} handleSubmit={handleSubmit} defaultValues={defaultValues}>
            <form noValidate {...rest} onSubmit={handleSubmit}>
                {children}
            </form>
        </FormProvider>
    );
};

// -------- PropTypes -------- //

Form.propTypes = {
    children: PropTypes.node.isRequired,
    onSubmit: PropTypes.func,
    onError: PropTypes.func,
    validator: PropTypes.shape({
        schema: PropTypes.object.isRequired,
        options: PropTypes.object,
        settings: PropTypes.object
    }),
    defaultValues: PropTypes.object
};
